import { render, staticRenderFns } from "./ZoneEdit.vue?vue&type=template&id=62740f16&scoped=true"
import script from "./ZoneEdit.vue?vue&type=script&lang=js"
export * from "./ZoneEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62740f16",
  null
  
)

export default component.exports